export type TimePreset =
  | 'today'
  | 'yesterday'
  | 'last7'
  | 'last30'
  | 'last90'
  | 'last365'
  | 'custom';

export type FilterState = {
  // time
  preset: TimePreset;
  start?: string; // ISO date (yyyy-mm-dd)
  end?: string;   // ISO date (yyyy-mm-dd)
  // multi-selects
  units: string[];          // process units
  operationTypes: string[]; // e.g. ['install','pickup']
  user?: string;            // user id/username
};

export const defaultFilters: FilterState = {
  preset: 'last7',
  units: [],
  operationTypes: [],
  user: undefined,
};
